import {
    CSSProperties,
    ChangeEventHandler,
    KeyboardEventHandler,
    RefObject,
    useContext,
    useRef,
    ReactNode,
    useState,
} from "react";
import { emailLogo, phoneLogo, calenderIcon } from "../../../../assets/assetsSVG";
import QuestContext from "../../../../components/QuestWrapper";

import "./css/InputModule.css";
import { useOnboarding } from "../modular/OnboardingContext";

const LogoType = {
    email: emailLogo,
    phone: phoneLogo,
    text: () => <></>,
    number: phoneLogo,
    date: calenderIcon,
};

interface PropType {
    placeholder?: string;
    style?: CSSProperties | undefined;
    onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
    onKeyUp?: KeyboardEventHandler<HTMLInputElement> | undefined;
    onKeyDown?: KeyboardEventHandler<HTMLInputElement> | undefined;
    iconColor?: string;
    value?: string;
    logoPosition?: "left" | "right" | "both";
    ref?: RefObject<HTMLInputElement>;
    numberErrorStyle?: CSSProperties | undefined;
    numbertext?: string;
    required?: boolean;
    regexKey?: string | undefined,
    regexMessage?: string,
    name?: string;
    preventFutureSelection?: boolean;
    preventPastSelection?: boolean;
    children?: ReactNode;
    className?: string;
    key?: string | number | undefined;
    validateInputRegex?: (validated: boolean) => void
}

export const NumberInputModule = ({
    placeholder,
    style,
    onChange,
    iconColor,
    value,
    onKeyUp,
    onKeyDown,
    ref,
    logoPosition = "right",
    numberErrorStyle,
    numbertext,
    required,
    regexKey = "",
    regexMessage,
    name,
    preventFutureSelection,
    preventPastSelection,
    key,
    validateInputRegex = () => { }
}: PropType) => {
    const { themeManager } = useOnboarding()

    const fallbackPattern = /^.+$/;

    const [isValidNumber, setIsValidNumber] = useState(true);

    const isValidRegex = (pattern: string | undefined): boolean => {
        try {
            new RegExp(pattern || '')
            return true;
        } catch {
            return false;
        }
    };

    const numberRegex = !regexKey ? fallbackPattern : isValidRegex(regexKey) ? new RegExp(regexKey) : fallbackPattern;

    const validateNumber = (inputValue: string) => {
        if (inputValue) {
            setIsValidNumber(numberRegex.test(inputValue));
            validateInputRegex(numberRegex.test(inputValue));
        } else {
            setIsValidNumber(true);
            validateInputRegex(true);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if (!!regexKey) {
            validateNumber(inputValue);
        }
        if (onChange) {
            onChange(e);
        }
    };

    const handleInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if (!!regexKey) {
            validateNumber(inputValue);
        }
    };

    return (
        <>
            <div className="q_input_cont" style={style}>
                {(logoPosition == "left" || logoPosition == "both") &&
                    LogoType["number"](iconColor || "#B9B9B9")}
                <input
                    type={"number"}
                    name={name}
                    placeholder={placeholder}
                    className="q_input_main_cont"
                    onChange={handleInputChange}
                    onKeyUp={onKeyUp}
                    onKeyDown={onKeyDown}
                    // value={value}
                    defaultValue={value}
                    ref={ref}
                    onBlur={handleInputBlur}
                    onWheel={(event) => {
                        event.currentTarget.blur();
                    }}
                    style={{
                        fontFamily: themeManager?.getFontFamily() || "'Figtree', sans-serif",
                        color: style?.color,
                    }}
                    required={required}
                    pattern={(!!regexKey) ? numberRegex.source : undefined}
                    key={key}
                />
                {(logoPosition == "right" || logoPosition == "both") &&
                    LogoType["number"](iconColor || "#B9B9B9")}
            </div>
            {(!!regexKey) && !isValidNumber && (
                <span style={numberErrorStyle} className="q-input-error-message">
                    {regexMessage || numbertext}
                </span>
            )}
        </>
    );
};
